import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, HiddenSpan } from 'components'
import * as Types from 'types'
import { getFormWideErrorMessage } from 'utils'
import { selectors as globalArtistSelectors } from 'artist-portal-reducer'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { waitFor } from 'lp-hoc'

import { PartnerPartnershipForm } from '../forms'

const propTypes = {
  onClose: PropTypes.func.isRequired,
  partnerOptions: PropTypes.arrayOf(Types.searchSuggestion),
  onSubmit: PropTypes.func.isRequired,
  onSubmitSuccess: PropTypes.func.isRequired,
  artist: Types.artist.isRequired,
  visibleSchoolYearId: PropTypes.number.isRequired,
}

const defaultProps = {
  partnerOptions: [],
  partner: {},
}

function AddPartnerPartnershipModal({
  onClose,
  partnerOptions,
  onSubmit,
  onSubmitSuccess,
  artist,
  visibleSchoolYearId,
}) {
  const [formWideError, setFormWideError] = useState(null)
  const [submitFailCount, setSubmitFailCount] = useState(0)

  const { partnerships } = artist
  const schools = partnerships.filter((p) => !!p.schoolId)
  const organizations = partnerships.filter((p) => !!p.organizationId)

  return (
    <Modal onClose={onClose}>
      <h2>Add New Partnership</h2>
      <p className="s-xsmall">
        If you don't see the organization, program, or school you're looking
        for, please reach out to your contact at the organization and ask them
        to update their profile with the relevant information. Once it's been
        added to artlook, the correct options should appear in the dropdown
        menu.
      </p>
      <div className="modal-content">
        <div role="alert" aria-atomic>
          {formWideError && (
            <p className="full-error-message">
              {formWideError} <HiddenSpan>{submitFailCount}</HiddenSpan>
            </p>
          )}
        </div>
        <PartnerPartnershipForm
          partnerOptions={partnerOptions}
          schoolPartnerships={schools}
          organizationPartnerships={organizations}
          visibleSchoolYearId={visibleSchoolYearId}
          onSubmit={onSubmit}
          onSubmitSuccess={onSubmitSuccess}
          onSubmitFail={(errors, _, submitError) => {
            setSubmitFailCount((sfc) => sfc + 1)
            const msg = getFormWideErrorMessage(errors, submitError)
            setFormWideError(msg)
          }}
        />
      </div>
    </Modal>
  )
}

AddPartnerPartnershipModal.propTypes = propTypes
AddPartnerPartnershipModal.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    artist: globalArtistSelectors.artist(state),
  }
}

const mapDispatchToProps = {}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  waitFor(['artist'])
)(AddPartnerPartnershipModal)
